
















import { AVATARS } from "@/resources/constants/avatars";
import { mixins } from "vue-class-component";
import Loader from "@/resources/mixins/loader/loader";
import { Component, Vue } from "vue-property-decorator";
import { i18n } from "@/resources/locales";
@Component({ name: "change-avatar-component" })
export default class ChangeAvatarComponent extends mixins(Vue, Loader) {
  selectId = 0;
  AVATARS = AVATARS;
  loading = false;
  city = false;
  mounted() {
    this.city = localStorage.getItem("city") == "ON" ? true : false;
    let spaceUser = null;
    if (this.city) {
      const data = {
        user: this.$store.getters["UserStore/getUser"],
      };
      spaceUser = data;
      this.selectId = spaceUser.user.avatar.id;
    } else {
      spaceUser = this.$store.getters["UserStore/getSpaceUser"];
      this.selectId = spaceUser.superSpaceUser.user.avatar.id;
    }
  }
  isSelected(id) {
    return id === this.selectId;
  }
  selectAvatar(id) {
    this.selectId = id;
    this.startLoader(this.$store);
    let userId = 0;
    if (this.city) {
      const data = {
        user: this.$store.getters["UserStore/getUser"],
      };
      userId = data.user.id;
    } else {
      const user = this.$store?.getters["UserStore/getSpaceUser"];
      userId = user.superSpaceUser.user.id;
    }
    this.$store.dispatch("UserStore/updateUserAvatarAction", {
      userId: userId,
      props: {
        avatar: { id },
      },
      callback: (response) => {
        setTimeout(() => {
          this.$vs.notification({
            color: "success",
            title: i18n.t("notifications.titles.success"),
            text: i18n.t("notifications.descriptions.avatarUpdate"),
          });
          this.stopLoader(this.$store);
        }, 1000);
      },
      callbackError: (error) => {
        this.stopLoader(this.$store);
        console.error("ERROR updateUserAvatarAction", error);
      },
    });
  }
}
